import React, { useState, useRef, useEffect } from 'react';

export default function Layout({ activeTab, setActiveTab, alertCount, children, viajes, alerts, onSelect, notificacionesActivas, setNotificacionesActivas, onSignOut }) {
  const [query, setQuery] = useState('');
  const [showResults, setShowResults] = useState(false);
  const searchRef = useRef(null);

  const navItems = [
  { id: 'dashboard', label: 'Dashboard GPS' },
  { id: 'alertas', label: 'Alertas', badge: alertCount },
  { id: 'viajes', label: 'Viajes' },
  { id: 'rutas', label: 'Rutas' },
  { id: 'clientes', label: 'Clientes' },
  { id: 'carriers', label: 'Carriers' },
  { id: 'reportes', label: 'Reportes' },
  { id: 'tareas', label: 'Tareas' },
  { id: 'crm', label: 'CRM' },
  { id: 'configuracion', label: 'Configuración' },
];
  const esHistorico = (v) => v.estado === 'completed' || v.estado === 'incomplete';

  const resultados = query.length < 2 ? [] : [
    ...(viajes || []).filter(v =>
      v.numero?.toLowerCase().includes(query.toLowerCase()) ||
      v.placas?.toLowerCase().includes(query.toLowerCase()) ||
      v.caja?.toLowerCase().includes(query.toLowerCase()) ||
      v.unidad?.toLowerCase().includes(query.toLowerCase()) ||
      v.conductor?.toLowerCase().includes(query.toLowerCase()) ||
      v.carrier?.toLowerCase().includes(query.toLowerCase()) ||
      v.ruta?.toLowerCase().includes(query.toLowerCase()) ||
      v.cliente?.toLowerCase().includes(query.toLowerCase()) ||
      v.factura?.toLowerCase().includes(query.toLowerCase())
    ).map(v => ({
      tipo: esHistorico(v) ? 'reporte' : 'viaje',
      label: v.numero,
      sub: `${v.ruta} · ${v.carrier} · ${v.placas || ''}`,
      color: v.estado === 'completed' ? '#3b82f6' : v.estado === 'incomplete' ? '#ef4444' : '#00e5a0',
      icon: esHistorico(v) ? '📊' : '🚛',
      pantalla: esHistorico(v) ? 'reportes' : 'viajes',
      viaje: v,
    })),
    ...(alerts || []).filter(a =>
      a.unidad?.toLowerCase().includes(query.toLowerCase()) ||
      a.conductor?.toLowerCase().includes(query.toLowerCase()) ||
      a.loc?.toLowerCase().includes(query.toLowerCase())
    ).map(a => ({
      tipo: 'alerta',
      label: a.unidad,
      sub: `${a.conductor} · ${a.loc}`,
      color: '#f59e0b',
      icon: '🚨',
      pantalla: 'alertas',
      viaje: null,
    })),
  ];

  useEffect(() => {
    const handleClick = (e) => {
      if (searchRef.current && !searchRef.current.contains(e.target)) {
        setShowResults(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleSelect = (r) => {
    setActiveTab(r.pantalla);
    if (onSelect && r.viaje) onSelect({ viaje: r.viaje, pantalla: r.pantalla });
    setQuery('');
    setShowResults(false);
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#0a0c10' }}>
      <div style={{ width: '220px', background: '#111318', borderRight: '1px solid #222730', display: 'flex', flexDirection: 'column', position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 100 }}>
        <div style={{ padding: '24px 20px', borderBottom: '1px solid #222730' }}>
          <img src="/logo-dark.svg" alt="LogiConnect" style={{ width: '160px', marginBottom: '4px' }} />
          <div style={{ fontSize: '10px', color: '#6b7280', letterSpacing: '3px', marginTop: '4px' }}>PLATAFORMA LOGÍSTICA</div>
        </div>
        <nav style={{ padding: '16px 0', flex: 1 }}>
          {navItems.map(item => (
            <div key={item.id} onClick={() => setActiveTab(item.id)}
              style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 20px', cursor: 'pointer', borderLeft: `3px solid ${activeTab === item.id ? '#00e5a0' : 'transparent'}`, background: activeTab === item.id ? 'rgba(0,229,160,0.06)' : 'transparent', color: activeTab === item.id ? '#00e5a0' : '#6b7280', fontSize: '14px', fontWeight: '500' }}>
              <span>{item.icon}</span>
              <span>{item.label}</span>
              {item.badge > 0 && (
                <span style={{ marginLeft: 'auto', background: '#ef4444', color: '#fff', fontSize: '10px', fontWeight: '700', borderRadius: '10px', padding: '1px 6px' }}>{item.badge}</span>
              )}
            </div>
          ))}
        </nav>
        <div style={{ padding: '16px 20px', borderTop: '1px solid #222730', fontSize: '12px', color: '#6b7280' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <div style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#00e5a0' }}></div>
            Sistema activo
          </div>
        </div>
      </div>

      <div style={{ marginLeft: '220px', flex: 1, display: 'flex', flexDirection: 'column' }}>
        <div style={{ background: '#111318', borderBottom: '1px solid #222730', padding: '0 32px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, zIndex: 50 }}>
          <div style={{ fontSize: '18px', fontWeight: '700', color: '#ffffff' }}>{activeTab.toUpperCase()}</div>
          <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
            <div ref={searchRef} style={{ position: 'relative' }}>
              <div style={{ display: 'flex', alignItems: 'center', background: '#181c24', border: '1px solid #222730', borderRadius: '8px', padding: '0 12px', gap: '8px', width: '280px' }}>
                <span style={{ color: '#6b7280', fontSize: '14px' }}>🔍</span>
                <input
                  value={query}
                  onChange={e => { setQuery(e.target.value); setShowResults(true); }}
                  onFocus={() => setShowResults(true)}
                  onKeyDown={e => { if (e.key === 'Enter' && resultados.length > 0) handleSelect(resultados[0]); }}
                  placeholder="Buscar viaje, placa, unidad..."
                  style={{ background: 'transparent', border: 'none', outline: 'none', color: '#e8eaf0', fontSize: '13px', padding: '8px 0', width: '100%' }}
                />
                {query && (
                  <button onClick={() => { setQuery(''); setShowResults(false); }}
                    style={{ background: 'transparent', border: 'none', color: '#6b7280', cursor: 'pointer', fontSize: '14px', padding: '0' }}>✕</button>
                )}
              </div>

              {showResults && query.length >= 2 && (
                <div style={{ position: 'absolute', top: '44px', right: 0, width: '380px', background: '#111318', border: '1px solid #222730', borderRadius: '10px', boxShadow: '0 8px 32px rgba(0,0,0,0.5)', zIndex: 200, overflow: 'hidden' }}>
                  {resultados.length === 0 ? (
                    <div style={{ padding: '20px', textAlign: 'center', color: '#6b7280', fontSize: '13px' }}>Sin resultados para "{query}"</div>
                  ) : (
                    <div>
                      <div style={{ padding: '8px 16px', fontSize: '11px', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '2px', borderBottom: '1px solid #222730' }}>
                        {resultados.length} resultado{resultados.length !== 1 ? 's' : ''} · Enter para abrir el primero
                      </div>
                      {resultados.map((r, i) => (
                        <div key={i} onClick={() => handleSelect(r)}
                          style={{ padding: '12px 16px', borderBottom: '1px solid #222730', cursor: 'pointer', display: 'flex', gap: '12px', alignItems: 'center' }}
                          onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,229,160,0.04)'}
                          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                          <div style={{ width: '32px', height: '32px', borderRadius: '8px', background: `${r.color}18`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', flexShrink: 0 }}>
                            {r.icon}
                          </div>
                          <div style={{ flex: 1 }}>
                            <div style={{ fontSize: '13px', fontWeight: '600', color: r.color, fontFamily: 'monospace' }}>{r.label}</div>
                            <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '2px' }}>{r.sub}</div>
                          </div>
                          <div style={{ fontSize: '10px', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '1px' }}>{r.tipo}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
            <div onClick={() => setNotificacionesActivas && setNotificacionesActivas(!notificacionesActivas)}
              title={notificacionesActivas ? 'Desactivar notificaciones' : 'Activar notificaciones'}
              style={{ width: '36px', height: '36px', background: notificacionesActivas ? 'rgba(0,229,160,0.1)' : '#181c24', borderRadius: '50%', border: `1px solid ${notificacionesActivas ? '#00e5a0' : '#222730'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: '16px' }}>
              {notificacionesActivas ? '🔔' : '🔕'}
            </div>
            <div onClick={onSignOut} title="Cerrar sesión" style={{ width: '36px', height: '36px', background: '#181c24', borderRadius: '50%', border: '1px solid #222730', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: '18px' }}>👤
</div>
          </div>
        </div>
        <div style={{ flex: 1, background: '#0a0c10', minHeight: '100vh' }}>
          {children}
        </div>
      </div>
    </div>
  );
}